import React from "react";
import { styled } from "@mui/system";
import MUIAvatar, { AvatarProps } from "@mui/material/Avatar";

export interface AvatarPropsExtended extends AvatarProps {
  bgColor?: string;
  color?: string;
}

export const ExtendedAvatar: React.FC<AvatarPropsExtended> = styled(
  React.forwardRef<HTMLDivElement, AvatarPropsExtended>((props, ref) => (
    <MUIAvatar ref={ref} {...props} />
  )),
  {
    name: "ExtendedAvatar",
    slot: "Root",
    shouldForwardProp: (prop) =>
      prop !== ("bgColor" || prop !== "color") && prop !== "myProp",
    overridesResolver: (props, styles) => []
  }
)(({ theme, bgColor, color }) => ({
  "&.MuiAvatar-root": {
    background: bgColor ? bgColor : theme.palette.primary.background,
    color: color ? color : theme.palette.primary.iconDefault
  },
  "&.MuiAvatar-rounded": {
    borderRadius: "4px"
  }
}));
